import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { CurrencyCode } from "../utils/currency";

interface CurrencyState {
  currency: CurrencyCode;
  setCurrency: (currency: CurrencyCode) => void;
}

export const useCurrencyStore = create<CurrencyState>()(
  persist(
    (set) => ({
      currency: "USD",
      setCurrency: (currency) => set({ currency }),
    }),
    {
      name: "currency",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
